<template>
  <el-table :data="tableServerInfo" border>
    <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
    <el-table-column prop="orderNum" label="订单号" align="center" width="220"></el-table-column>
    <el-table-column prop="productName" label="套餐名" align="center" width="220"></el-table-column>
    <el-table-column prop="useFlow" label="已使用" align="center" width="120"></el-table-column>
    <el-table-column prop="monthFlow" label="总分钟" align="center" ></el-table-column>
    <el-table-column prop="status" label="套餐状态" align="center" ></el-table-column>
    <el-table-column prop="startTime" label="开始时间" align="center" width="220"></el-table-column>
    <el-table-column prop="endTime" label="结束时间" align="center" width="220"></el-table-column>
    <el-table-column prop="operatorCode" label="国际编码" align="center" v-if="adminShow" width="180" :show-overflow-tooltip="true" ></el-table-column>
    <el-table-column label="操作" align="center" width="200" v-if="adminShow">
      <template slot-scope="scope">
        <el-button size="mini" type="danger" v-if='!scope.row.startTime && scope.row.status !== "已转移"' @click="activeOrderVoice(scope.row.orderNum)" style="background:#24D2B5;border: 1px solid #24D2B5;width:72px" v-hasPermi="['inter:active:voice']">激活套餐</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import { cardVoiceProduct } from "@/api/api.js"; //资费列表
import { mannualActiveVoice } from "@/api/international.js";
export default {
  props: {
    iccid: {
      type: [String]
    },
    channel: {
      type: [String]
    },

  },
  data() {
    return{
      tableServerInfo:[],
    }
  },
  computed: {
    adminShow () {
      return this.$store.getters.user.userType =='1'
    }
  },
  watch: {
    iccid() {
      this.initData();
    }
  },
  methods: {
    Packagestatus(status) {
      let obj = {
        1: "未使用",
        2: "使用中",
        3: "已使用",
        4: "已过期",
        5: "已转移",
        6: "已作废",
      };
      return obj[status];
    },
    changeIccid(iccid){
      this.iccid = iccid;
    },
    // 获取列表的数据
    initData(){
      if(!this.iccid || this.iccid == ''){
        return;
      }
      let params = {
        iccid : this.iccid
      };
      cardVoiceProduct(params).then(res => {
        if(res.data.code == 200){
          this.tableServerInfo = res.data.data;
          this.tableServerInfo.map((item,index)=>{
            item.ids = index + 1;
            item.status = this.Packagestatus(item.status);
          })
        }
      })
    },
    //手动激活
    activeOrderVoice(row){
      this.$confirm('是否继续激活套餐?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          orderNum:row,
          iccid : this.iccid
        }
        mannualActiveVoice(params).then(res => {
          if (res.data.code == 200){
            this.initData();
            this.$message({
              type: 'success',
              message: '激活成功!'
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消激活'
        });          
      });
    }
  },
  created() {
   this.initData();
  }
};
</script>

<style scoped lang="less">

</style>


